import { getPublicApiBaseUrl } from './publicApiBase';

/**
 * Turn a stored media path into a browser-loadable URL.
 * File uploads are saved as `/uploads/general/…`; that path only works on the API host
 * (or via a Vite/Vercel rewrite). Prefix with the public API origin when we know it.
 */
export function resolveMediaUrl(url?: string | null): string {
  if (!url) return '';
  const trimmed = url.trim();
  if (!trimmed) return '';
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  if (trimmed.startsWith('/uploads/')) {
    const base = getPublicApiBaseUrl();
    return base ? `${base}${trimmed}` : trimmed;
  }
  return trimmed;
}
